const zh_CN = {
  "intl-area-tj": "天津",
  "intl-Home-tjAboutUs": "联想天津未来中心",
  "intl-tjAboutUS-TheTimeThat": "- 周一至周五：9:00-18:00 （需提前预约）",
  "intl-tjAboutUS-ClosedTime": "- 周六、周日",
  "intl-tjAboutUS-yuyue1": "• 联想未来中心目前仅针对团体访客开放参观预约",
  "intl-tjAboutUS-yuyue2": "• 需至少提前5天进行预约",
  "intl-tjAboutUS-yuyue3": "• 参观预约后，是否预约成功请以邮件为准",
  "intl-tjAboutUS-VisitorsGuide1": "• 为保证最佳的参观体验，每次参观人数需控制在30人以内",
  "intl-tjAboutUS-VisitorsGuide2": "• 18岁以下访客需由至少一名成人陪同方可入场",
  "intl-tjAboutUS-VisitorsGuide3": "• 行动不便的参观者需由成年人陪同",
  "intl-tjAboutUS-VisitorsGuide4": "• 禁止携带宠物进入展厅",
  "intl-tjAboutUS-VisitorsGuide5": "• 请勿大声喧哗并请将手机设置为静音或震动模式以免影响他人参观",
  "intl-tjAboutUS-VisitorsGuide6": "• 展厅内禁止吸烟、进食",
  "intl-tjAboutUS-VisitorsGuide7": "• 禁止损毁建筑、设施和展品，乱涂乱画",
  "intl-tjAboutUS-VisitorsGuide8": "• 场馆内请勿奔跑、追逐、攀爬、躺卧",
  "intl-tjAboutUS-VisitorsGuide9": "• 请协助维持展厅内的参观秩序和良好的参观环境",
  "intl-tjAboutUS-VisitorsGuide10": "• 出于展项安全的考虑，仅在场馆内指定区域允许照相、录音（电视节目拍摄需提前与相关工作人员沟通）",
  "intl-tjAboutUS-Facilities2": "• 为方便您出行，联想未来中心设有访客专用停车位。",
  "intl-tjAboutUS-Facilities6": "• 位置：联想天津未来中心一层前台",
  "intl-tjAboutUS-Facilities7": "• 服务台有联想未来中心手册供访客初步了解",
  "intl-tjAboutUS-site1": "天津市滨海新区空港经济区纬九路联想天津智慧创新服务产业园5号门1号楼",
  "intl-tjAboutUS-ditieTitle": "公交地铁：",
  "intl-tjAboutUS-ditie": "乘坐528路公交到达空港天铁公交站，后沿经三路向南行走10分钟到达联想智慧创新服务产业园，从5号门进入，步行到达一号楼联想天津未来中心",
  "intl-tjAboutUS-jiacheTitle": "驾车：",
  "intl-Menu-tjAddress": "联想天津未来中心，天津市滨海新区空港经济区纬九路联想天津智慧创新服务产业园5号门1号楼",
  "intl-tjcenter-sec1title": "1层“从未来到未来”-数字文明艺术展",
  "intl-tjcenter-sec1des1": "由联想集团联袂UCCA集团旗下UCCA Lab精心打造的“从未来到未来——数字文明艺术展”，艺术家们将丰富的艺术作品与联想创新故事相互交织呈现，以艺术和科技的完美结合，引领大家踏上探索人类数字文明之旅。",
  "intl-tjcenter-sec1des2": "该展览共分为未来序曲、奔腾时代、数字新生、瞬息万物、遇见未来等五个篇章。",
  "intl-tjcenter-sec1des3": "“未来序曲”作为开篇，以一系列声音艺术作品回应通信时代下人们探索未来的无限好奇心,展示了数字文明时代的来临。“奔腾时代”篇章则以个人计算机的迭代为线索，带领观众迈入一个高速发展的“奔腾时代”，呈现了科技飞速发展的景象。“数字新生”呈现出一幅21世纪之初五光十色的都市景观，跃动之间，观众随即坠入前沿科技构建的“瞬息万物”的当下。并最终历经一片虚拟现实、人工智能等新兴技术构成的数字海洋，展现了数字世界的无限可能，并在遨游间“遇见未来”的自己。",
  "intl-tjcenter-sec2title": "2层行业数字化之旅",
  "intl-tjcenter-sec2des1": "来到展厅二楼，呈现在我们面前的是一个巨大的算力魔方，它象征着联想先进的技术和计算能力，接下来围绕着算力这一智能化变革的核心要素，联想端-边-云-网全栈产品依次铺陈开来。",
  "intl-tjcenter-sec2des2": "在这里您将能看到数据从终端生成通过网络到达边缘端进行轻量处理，再到达云端，最后通过网络返回终端的整个生命周期与迭代历程。",
  "intl-tjcenter-sec2des3": "依托于“端-边-云-网-智”新IT技术架构，联想通过云网融合，“边-云-网”协同发力，针对各领域的痛点、挑战与未来发展趋势，融合人工智能，大数据，边缘计算等技术，让智能化覆盖政府、教育、金融、公交能、文旅等各类行业场景。我们将看到联想在不同行业、不同领域的以AI为驱动的智能化变革实践案例，以及面向未来的智能解决方案。",
  "intl-tjcenter-sec3title": "3层：联想全球供应链智能体验空间",
  "intl-tjcenter-sec3des1": "三楼是联想全球供应链互动体验展区。联想集团连续九年入围全球最具权威的供应链榜单Gartner25强，彰显了联想在供应链数字化方面的能力。",
  "intl-tjcenter-sec3des2": "在这里，你将能以第一视角看到联想如何利用自研的供应链控制塔SCI的数字供应链解决方案和供应链智慧运营解决方案赋能企业，整合供应链各环节，从订单下达到履约、计划、采购、制造、物流最后交付的整体生产计划、全流程执行的数字供应链管理。以及联想打造的涵盖“绿色生产+供应商管理+绿色物流+绿色回收+绿色包装”五个维度和一个“绿色信息披露平台”的智能环保供应链解决方案。",
  "intl-tjltzngccenter-sec1title": "制造历程",
  "intl-tjltzngccenter-sec1des1": "由联想全球制造布局​、联想全球制造发展历程​、天津基地发展历程​、沉浸式介绍影片组成，是联想天津成长和发展的集中体现。",
  "intl-tjltzngccenter-sec2title": "智能生产",
  "intl-tjltzngccenter-sec2des1": "智能生产模块",
  "intl-tjltzngccenter-sec2des2": "高自动智能生产车间",
  "intl-tjltzngccenter-sec2des3": "高性能智能笔记本生产线（SMT）",
  "intl-tjltzngccenter-sec2des4": "高自动化智能笔记本生产线",
  "intl-tjltzngccenter-sec2des5": "智能制造18般武艺",
  "intl-tjltzngccenter-sec2des6": "数字化中控平台",
  "intl-tjltzngccenter-sec3title": "智慧物流",
  "intl-tjltzngccenter-sec3des1": "智慧物流影片介绍、零碳智能仓储集成方案立体仓实景参观以及数字孪生互动等。",
  "intl-tjltzngccenter-sec4title": "零碳空间",
  "intl-tjltzngccenter-sec4des1": "零碳工厂介绍​、光伏设备应用​、绿植种植​等零碳园区设计理念及ESG成绩介绍。",
  "intl-tjltzngccenter-sec5title": "智慧园区",
  "intl-tjltzngccenter-sec5des1": "智慧园区愿景介绍、千层镜打卡点位及人文墙展示。",

  "intl-tjcenter-f1Title2":"“从未来到未来”-数字文明艺术展",
  "intl-tjcenter-f2Title2":"3S行业智能化展区",
  "intl-tjcenter-f3Title2":"联想智能制造及全球供应链互动体验空间",
  "intl-tjcenter-f1Des":"由联想集团联袂UCCA集团旗下UCCA Lab精心打造的“从未来到未来——数字文明艺术展”，通过艺术作品与联想创新故事相互交织呈现，分五个篇章呈现数字文明的发展历程及数字世界的无限可能。",
  "intl-tjcenter-f2Des":"依托于“端-边-云-网-智”新IT技术架构，联想通过云网融合，“边-云-网”协同发力，针对各领域的痛点、挑战与未来发展趋势，融合人工智能，大数据，边缘计算等技术，让智能化覆盖教育、金融、公交能、文旅等各类行业场景。",
  "intl-tjcenter-f3Des":"面对产业智能化转型和制造业企业IT现代化需求，联想以全栈式、领先的技术和全周期陪伴式服务，卓越的供应链，赋能制造业实现降本增效、安全可控、零碳制造等智能化转型需求。",
  "intl-tjcenter-1szwmyszTitle":"数字文明艺术展",
  "intl-tjcenter-1szwmyszDes1":"由联想集团联袂UCCA集团旗下UCCA Lab精心打造的“从未来到未来——数字文明艺术展”，通过艺术作品与联想创新故事相互交织呈现，分五个篇章回溯人类数字文明的发展历程。",
  "intl-tjcenter-1szwmyszDes2":"“未来序曲”作为开篇，以一系列声音艺术作品回应通信时代下人们探索未来的无限好奇心,展示了数字文明时代的来临。“奔腾时代”篇章则以个人计算机的迭代为线索，带领观众迈入一个科技高速发展的时代。“数字新生”呈现出一幅21世纪之初五光十色的都市景观，跃动之间，观众随即坠入前沿科技构建的“瞬息万物”的当下。并最终历经一片虚拟现实、人工智能等新兴技术构成的数字海洋，展现了数字世界的无限可能，并在遨游间“遇见未来”的自己。",
  "intl-tjcenter-2xitTitle":"新IT",
  "intl-tjcenter-2xitDes1":"创新是联想持续引领产业变革的基石。锚定“人工智能”和“计算”，联想前瞻性布局智能化变革，并基于“端-边-云-网-智”的“新IT”技术架构，持续构建AI内嵌的智能终端、AI导向的基础设施和AI原生的方案服务。",
  "intl-tjcenter-3zhzfTitle":"智慧政府",
  "intl-tjcenter-3zhzfDes1":"融合物联网、大数据、人工智能等技术，提供数字化底座、集成与资源整合、生态构建的全生命周期智慧政府解决方案，辐射交通、城市、文旅等领域，在实践中为政府提供能够成熟落地、稳定可行的数字化技术和服务。",
  "intl-tjcenter-4zhylTitle":"智慧医疗",
  "intl-tjcenter-4zhylDes1":"利用边云网基础设施、大数据、AI、区块链等技术，基于20余年医疗行业智能化经验，为医疗行业打造稳定可靠的数字底座、定制化全场景解决方案，提供全栈全周期服务，助力医疗行业数字化、信息化转型。",
  "intl-tjcenter-5zhjyTitle":"智慧教育",
  "intl-tjcenter-5zhjyDes1":"以“科技至简，教育为学”为理念，将教育与产业实践相结合打造的智慧教育解决方案体系。面向高教，以算力赋能科研创新，助力院校人才发展和数字化建设；面向职教，以产业实践赋能实训与教学，助力人才培养；面向普教，以教师为中心，打造智能备授课解决方案。",
  "intl-tjcenter-6zhgjnTitle":"智慧公交能",
  "intl-tjcenter-6zhgjnDes1":"联想依托新IT技术架构，围绕智慧交通、交通调度、高铁、轨道交通建设等场景，打造的从智能终端到数据中心的全栈系统、服务和解决方案,以及依托联想“云、大、物、移、智、边、区”等新技术平台和产品，自研的一系能源行业解决方案，涵盖电力、煤矿、石油等行业，有效提升能源企业自动化、数字化、集成化、可视化、模型化、智能化水平。",
  "intl-tjcenter-7zhjrTitle":"智慧金融",
  "intl-tjcenter-7zhjrDes1":"依托AI、大数据、分布式云等技术，为银行、保险、证券等金融行业客户在数字化转型过程中提供从桌面到数据中心的硬件基础设施、端到端解决方案及全生命周期服务，助力客户走向金融科技4.0时代。",
  "intl-tjcenter-8znzzTitle":"智能制造及全球供应链展区",
  "intl-tjcenter-8znzzDes1":"联想数字化供应链解决方案：基于数字化平台构建供应链业务的计划体系，打造端到端整体生产计划和执行方案，涵盖销售预测、物料需求、生产计划、自动排程、交期承诺、发货等核心功能，支持制造业供应链业务的快速增长和数字化转型；联想智能制造解决方案：基于AI、边缘计算等技术，依托多种硬软件产品及智能管理平台打造的涵盖产线数字化、AI工业质检、绿色制造、智能工厂等在内的智能制造方案体系。",
};
export default zh_CN;


// WEBPACK FOOTER //
// ./src/langConfig/tj/zh-CN.js